export async function locationIndexUseCase(page, per_page, search, fields, sort_by, locationRepository) {
    const result = await locationRepository.index(page, per_page, search, fields, sort_by);

    result.data.data.forEach(x => {
        const entity = new locationRepository.model_index(x);

        if (!entity.isValid()) {
            throw new Error("location index inválido");
        }
    })

    return result.data;
}